import { AvailabilityState } from '@gn-audio/jss-core';

import { StandardPriceModel } from 'api/pricesApi/pricesModel';

export const sumPrices = (prices: StandardPriceModel[]): StandardPriceModel | undefined => {
  if (!prices.length) return;

  return prices.reduce((summed, price) => {
    const discountedPrice = (summed.discountedPrice ?? 0) + (price.discountedPrice ?? 0);
    const discountedPriceWithoutVat =
      (summed.discountedPriceWithoutVat ?? 0) + (price.discountedPriceWithoutVat ?? 0);
    const listedPriceWithoutVat =
      (summed.listedPriceWithoutVat ?? 0) + (price.listedPriceWithoutVat ?? 0);
    const listedPrice = (summed.listedPrice ?? 0) + (price.listedPrice ?? 0);
    const lowestPriceInLastMonth =
      (summed.lowestPriceInLastMonth ?? 0) + (price.lowestPriceInLastMonth ?? 0);

    const isDiscounted = price.isDiscounted || summed.isDiscounted;
    const currency = price.currency;
    const availabilityState = Math.max(
      price.availabilityState ?? AvailabilityState.Add,
      summed.availabilityState ?? AvailabilityState.Add
    );

    return {
      listedPriceWithoutVat,
      listedPrice,
      lowestPriceInLastMonth,
      discountedPrice,
      discountedPriceWithoutVat,
      isDiscounted,
      currency,
      availabilityState,
    };
  }, {});
};
